module.exports = __webpack_public_path__ + "static/img/logo_en.64dc4a0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/en/logo_en.svg
// module id = eV2S
// module chunks = 96